// extracted by mini-css-extract-plugin
export default {"Link":"ConceptLink_Link__piJ9b"};